












import Headers from '@/components/header/Headers.vue';
import Footers from '@/components/Footers.vue';
import {Vue, Component} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import NcpLayer from '@/components/common/ncpLayerPopup/Index.vue';
import LayerPopView from '@/components/pop/LayerPopView.vue';
import { NCUA_VUES } from '@/const/common';

const termsModule = namespace('terms');

@Component({
  components: {Headers, Footers, NcpLayer, LayerPopView}
})
export default class DefaultView extends Vue {
  @State private onGnb!: boolean;
  @termsModule.Getter('getNcpLayerIsShow') private getNcpLayerIsShow!: boolean;
  @termsModule.Getter('getNcpLayerIsExist') private getNcpLayerIsExist!: boolean;
  @termsModule.Getter('getNcpLayerInfo') private popInfo!: {};

  private gnbid: number = -1;
  private className: string = '';

  get useNcua() {
    return NCUA_VUES.includes(this.$route.name || '');
  }
}
